<script lang="ts">
    import type {MessageVideo} from "./Types";
    import Video from "./Video.svelte";
    import FormattedText from "./FormattedText.svelte";

    export let entity: MessageVideo
    export let attachments: ChatMessageAttachmentData[]
</script>
<div class="alert alert-warning m-0">
    Відео <br/>
    <FormattedText entity="{entity.caption}"/>
    <Video entity="{entity.video}" {attachments}/>
</div>
